<template lang="pug">
div
  p Define <mj m="\vb{c_i}(\ymin) = \vb{0}"/> and <mj m="\dv[]{\vb{c_i}}{y}(\ymin) = \left(0, \dots, 0, 1, 0, \dots, 0\right)^{\intercal}"/>. For a fixed energy <mj m="E" />, propagate these intial values to <mj m="\ymax" />.

  div(style="position: relative")
    .eigCContainer(
      v-for="i of [0,1,2,3]",
      :key="`s${i}`",
      :class="{ cHide: step > 2 }",
      :style="{ position: 'absolute', width: `${704 / 4}px`, right: `${(704 / 4) * (3 - i)}px`, top: '0' }"
    )
      .center
        is_canvas(
          :index="i + 1",
          style="width: 160px; height: 160px",
          :canvasScale="canvasScale",
          :progress="progress"
        )
        mj(display) \vb{c_{{ i }}}(y)
    .eigCContainer(
      :class="{ cHide: step <= 2 }",
      style="position: absolute; right: 40px"
    )
      is_canvas.center(
        :index="0",
        style="width: 160px; height: 160px",
        :canvasScale="canvasScale"
      )
      mj(display) \vb{c}(y) = \sum_i a_i \vb{c_i}(y)

  .cMath(:class="{ cHide: !lastStep }", style="width: 450px; margin-top: 30px")
    p 
      | If there exists a non-trivial solution of
      mj(display) \vb{c}(\ymax) := \sum_i a_i \vb{c_i}(\ymax) = \vb{0}
      | then <mj m="E"/> is an eigenvalue.
</template>

<script>
import ISCanvas from "./IxaruShootingCanvas.vue";
import Animation from "./Animation.vue";
import MathJax from "./MathJax.vue";

const cycleTime = 10000;

export default {
  props: {
    canvasScale: {
      value: 1,
      type: Number,
    },
    step: {
      value: 1,
      type: Number,
    },
  },
  mixins: [Animation],
  components: { is_canvas: ISCanvas, mj: MathJax },
  created() {
    this.$on("tick", () => {
      if (this.time >= cycleTime) {
        this.stopAnimation();
        this.time = cycleTime;
      }
    });
  },
  mounted() {
    this.updateStep();
  },
  data() {
    return {
      lastStep: false,
    };
  },
  watch: {
    step() {
      this.updateStep();
    },
  },
  computed: {
    progress() {
      if (this.step == 1) return 0.1;
      else if (this.step == 2)
        return Math.ceil(2 + (18 * this.time) / cycleTime) / 20;
      else return 1;
    },
  },
  methods: {
    updateStep() {
      if (this.step == 1) {
        this.stopAnimation();
        this.lastStep = false;
      } else if (this.step == 2) {
        this.startAnimation();
        this.lastStep = false;
      } else if (this.step == 3) {
        this.stopAnimation();
        setTimeout(() => {
          if (this.step == 3) this.lastStep = true;
        }, 5000);
      }
    },
  },
};
</script>

<style scoped>
.eigCContainer {
  transition: right 3s, opacity 6s;
}

.eigCContainer.cHide {
  right: 40px !important;
  opacity: 0;
}

.cMath {
  opacity: 1;
  transition: opacity 2s;
}

.cMath.cHide {
  opacity: 0;
}
</style>